export const actionOptions = {
  "all": [
    {
      title: "Activate Rule",
      cls: "bulk-activate-rule",
      icon: "toggle-off",
      disabled:true
    },
    {
      title: "Deactivate Rule",
      cls: "bulk-deactivate-rule",
      icon: "toggle-on",
      disabled:true
    }
  ],
  "actions": [
    {
      title: "Edit Rule",
      cls: "edit-rule",
      icon: "pencil",
      disabled:false
    },
	{
      title: "Activate/Deactivate",
      cls: "",
      icon: "",
      disabled:false
    },
    {
      title:"Duplicate Rule",
      cls:"duplicate-rule",
      icon:"clone",
      disabled:false
    }
  ]
};



// WEBPACK FOOTER //
// ./src/pages/returnDispositionRules/filter/actionOptions.js